<i18n>
de:
  Arrival or departure time: Ankunfts- oder Abfahrtszeit
  Arrive by: Ankunft vor
  Depart at: Abfahrt um
  Hour: Stunde
  Minute: Minute
  Today: Heute
  Another day: Ein anderer Tag
  Date: Datum
  Time: Uhrzeit
</i18n>
<template>
<div>
  <v-select
    :items="timeModes"
    v-model="timeMode"
    :label="$t('Arrival or departure time')"
    box
    class="px-2"
    prepend-icon="start"
  ></v-select>
  <v-menu
    v-if="timeMode"
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="time"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="time"
          :label="$t('Time')"
          readonly
          v-bind="attrs"
          v-on="on"
          box
          class="px-2"
          prepend-icon="schedule"
        ></v-text-field>
      </template>
      <v-time-picker
        v-if="menu"
        v-model="time"
        full-width
        format="24hr"
        @click:minute="$refs.menu.save(time)"
      ></v-time-picker>
  </v-menu>
  <v-menu
    v-if="timeMode"
    ref="dateMenu"
    v-model="dateMenu"
    :close-on-content-click="false"
    :return-value.sync="date"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
    >
    <v-date-picker
    v-model="rawDate"
    :label="$t('Date')"
    locale="de-de"
    first-day-of-week="1"
    @input="dateMenu = false"
  ></v-date-picker>
  <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="selectedDate"
            :label="$t('Date')"
            readonly
            v-bind="attrs"
            v-on="on"
            box
            class="px-2"
            prepend-icon="today"
          ></v-text-field>
        </template>
  </v-menu>
</div>
</template>

<script>
import { pad2 } from './routingUtils';

export default {
  data: () => ({
    timeMode: 'departure',
    rawDate: undefined,
    time: null,
    menu: false,
    dateMenu: false
  }),
  mounted () {
    const today = new Date();
    const hours = today.getHours() <= 10 ? '0' + today.getHours() : today.getHours()
    const minutes = today.getMinutes() <= 10 ? '0' + today.getMinutes() : today.getMinutes()
    this.time = hours + ':' + minutes
  },
  computed: {
    timeModes () {
      return [{ text: this.$t('Arrive by'), value: 'arrival' }, { text: this.$t('Depart at'), value: 'departure' }]
    },
    selectedDate () {
      return this.formatDate(this.date)
    },
    date () {
      if (!this.isDateSpecified) {
        const now = (new Date());
        const todayDate = `${now.getFullYear()}-${pad2(now.getMonth() + 1)}-${pad2(now.getDate())}`;
        return todayDate;
      }
      return this.rawDate;
    },
    isDateSpecified () {
      return this.rawDate;
    },
    isTimeValid () {
      return !(this.hour !== undefined && this.minute === undefined);
    },
    anything () {
      return [this.timeMode, this.time, this.date, this.isDateSpecified, this.isTimeValid];
    }
  },
  watch: {
    anything () {
      console.log(this.date, this.isTimeValid, this.isDateSpecified, 'timetime')
      this.$emit('change', {
        timeMode: this.timeMode,
        time: this.time,
        date: this.date,
        isDateSpecified: this.isDateSpecified,
        isTimeValid: this.isTimeValid
      });
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    }
  }
}
</script>

<style scoped>
#hour {
  text-align: right;
}

.colon {
  text-align: center;
  vertical-align: bottom;
  margin-top:auto;
  margin-bottom:auto;
  font-size:26px;
  padding-bottom:8px;
}


</style>



// WEBPACK FOOTER //
// src/components/routing/DateTimePicker.vue